import axios from 'axios';
import http from 'http';
import https from 'https';
import qs from 'qs';
import { Sentry } from 'utils';
import tracer from '../tracer';
import { AXIOS_CONFIG } from './config';

/**
 * The maximum count of sponsored products we should display
 */
const SP_MAX_COUNT = 4;

/**
 *
 * @param {string} type : "search" or "category"
 * @param {string or number} term : query or category ID
 */
export const getSponsoredProductsURL = (type, term, baseUrl, platform) => {
    if (!type || !term || !baseUrl) return null;
    if ((type !== 'category' && type !== 'search') || !platform) return null;
    const parameters = qs.stringify(
        { [type]: term, platform },
        { format: 'RFC1738' },
    );
    return {
        method: 'GET',
        headers: {
            Host: baseUrl,
        },
        url: `${process.env.ENVOY_PROXY_SCHEME || 'https'}://${process.env
            .ENVOY_PROXY_HOST || baseUrl}/${
            AXIOS_CONFIG.ENDPOINT
        }?${parameters}`,
    };
};

const instance = axios.create({
    timeout:
        parseInt(process.env.MS_SPONSORED_PRODUCTS_TIMEOUT, 10) ||
        AXIOS_CONFIG.TIMEOUT,

    httpAgent: new http.Agent({
        keepAlive: true,
    }),

    httpsAgent: new https.Agent({
        rejectUnauthorized: false,
        keepAlive: true,
    }),
});

export const fetchAds = tracer.wrap(
    'fragment.listing.fetchAds',
    (listingData, baseUrl, platform) => {
        const { type } = listingData;
        const term =
            type === 'search' ? listingData.query : listingData?.params?.id;

        const defaultValues = {
            adsInfo: [],
            isDataFetched: true,
        };

        const url = getSponsoredProductsURL(type, term, baseUrl, platform);

        if (!url) {
            return Promise.resolve(defaultValues);
        }

        return instance(url)
            .then(({ data }) => {
                const adsInfo =
                    (data && data.content?.slice(0, SP_MAX_COUNT)) || [];
                return {
                    ...defaultValues,
                    adsInfo,
                };
            })
            .catch(err => {
                Sentry.captureException(err);
                return {
                    ...defaultValues,
                    err: err.message,
                };
            });
    },
);

export const PRODUCTS_CARDS_POSITIONS = [5, 11, 14, 18];

export default {
    fetchAds,
    PRODUCTS_CARDS_POSITIONS,
};
